import {DosageLimitsMatrix} from '@/modules/drug-catalog/components/dosage-limits-matrix'
import {
  DrugItemDrawerAboutSection,
  DrugItemDrawerClassificationSection,
} from '@/modules/drug-catalog/components/drug-item-drawer/drug-item-drawer-sections'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {useSupportiveMedicationDrugContext} from '@/shared/contexts/supportive-medication-drug'
import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'

export function AboutTab() {
  const {t} = useTranslate('common')
  const {supportiveMedicationDrug} = useSupportiveMedicationDrugContext()

  const doseLimits = supportiveMedicationDrug?.supportiveMedicationDetails?.doseLimits

  const {dosing, safetyLimits} = useMemo(() => {
    return {
      dosing: [
        {
          label: t('calculation_mode'),
          value: supportiveMedicationDrug.supportiveMedicationDetails?.doseCalcMode
            ? t(supportiveMedicationDrug.supportiveMedicationDetails?.doseCalcMode)
            : undefined,
        },
        {label: t('unit'), value: supportiveMedicationDrug.supportiveMedicationDetails?.doseUnit?.ucumCode},
        {
          label: t('rounding_mode'),
          value: supportiveMedicationDrug.supportiveMedicationDetails?.roundingMode
            ? t(supportiveMedicationDrug.supportiveMedicationDetails?.roundingMode)
            : null,
        },
        {label: t('precision'), value: supportiveMedicationDrug.supportiveMedicationDetails?.dosePrecision},
      ],

      safetyLimits: [
        {
          label: t('overdose_level'),
          value: supportiveMedicationDrug.supportiveMedicationDetails?.overdosePreventionLevel
            ? t(supportiveMedicationDrug.supportiveMedicationDetails?.overdosePreventionLevel)
            : null,
        },
      ],
    }
  }, [t, supportiveMedicationDrug])

  return (
    <Tabs.Content value="about" spaceY="8" display="flex" flexDirection="column">
      <DrugItemDrawerAboutSection drugItem={supportiveMedicationDrug} />

      <DrugItemDrawerClassificationSection drugItem={supportiveMedicationDrug} />

      <DataSection label={t('dosing')}>
        <DataList items={dosing} />
      </DataSection>

      <DataSection label={t('safety_limits')}>
        <DataList items={safetyLimits} />

        <DosageLimitsMatrix
          bordered
          color="fg.muted"
          fontWeight="normal"
          unit={supportiveMedicationDrug.supportiveMedicationDetails?.doseUnit?.ucumCode}
          renderCellContent={({row, col}) => doseLimits?.[row.key]?.[col.key]}
        />
      </DataSection>
    </Tabs.Content>
  )
}
